<template>
  <v-tooltip bottom :max-width="maxWidth">
    <template v-slot:activator="{ on }">
      <v-icon
        :small="small"
        :color="color"
        v-on="on"
        :style="{ cursor: 'help', marginLeft: marginLeft }"
      >{{ icon }}</v-icon>
    </template>
    <span style="white-space: pre-line">{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "HelpIcon",
  props: {
    text: { type: String, required: true },
    icon: { type: String, default: "help_outline" },
    small: { type: Boolean, default: true },
    color: { type: String, default: "grey" },
    maxWidth: { type: [String, Number], default: 280 },
    marginLeft: { type: String, default: "4px" },
  },
};
</script>
